window.PS.globalBus = new Vue();
